import React from "react";
import { injectIntl, FormattedMessage } from "react-intl";
import styles from "./AboutSection.module.css";
import ScrollReveal from "../components/ScrollReveal";
import {
  FaImages,
  FaCube,
  FaMap,
  FaColumns,
  FaRobot,
  FaGlobe,
} from "react-icons/fa";

const capabilities = [
  {
    icon: FaImages,
    titleId: "about.cap.photos.title",
    titleDefault: "Galeria de Fotos",
    descId: "about.cap.photos.desc",
    descDefault: "Visualize centenas de imagens de drone organizadas por projeto."
  },
  {
    icon: FaGlobe,
    titleId: "about.cap.tour.title",
    titleDefault: "Tour Virtual 360°",
    descId: "about.cap.tour.desc",
    descDefault: "Explore ambientes em visão panorâmica completa pelo navegador."
  },
  {
    icon: FaCube,
    titleId: "about.cap.cloud.title",
    titleDefault: "Nuvem de Pontos 3D",
    descId: "about.cap.cloud.desc",
    descDefault: "Modelos tridimensionais completos carregados diretamente no browser."
  },
  {
    icon: FaMap,
    titleId: "about.cap.geo.title",
    titleDefault: "Mapas GeoView",
    descId: "about.cap.geo.desc",
    descDefault: "GeoViews e mapas georreferenciados com camadas interativas."
  },
  {
    icon: FaColumns,
    titleId: "about.cap.compare.title",
    titleDefault: "Comparação de Imagens",
    descId: "about.cap.compare.desc",
    descDefault: "Deslize entre dois momentos do projeto e mostre a evolução."
  },
  {
    icon: FaRobot,
    titleId: "about.cap.ai.title",
    titleDefault: "Relatórios com IA",
    descId: "about.cap.ai.desc",
    descDefault: "Análise técnica automática gerada por inteligência artificial."
  }
];

const AboutSection = ({ intl }) => {
  return (
    <section id="sobre" className={styles.about}>
      <div className={styles.aboutBg} aria-hidden="true">
        <div className={styles.bgGrid} />
        <div className={styles.bgGlow} />
      </div>

      <div className={styles.container}>
        <ScrollReveal>
          <div className={styles.header}>
            <div className={styles.sectionLabel}>
              <span className={styles.labelLine} />
              <FormattedMessage id="about.label" defaultMessage="A plataforma" />
              <span className={styles.labelLine} />
            </div>
            <h2 className={styles.sectionTitle}>
              <FormattedMessage id="aboutSection.title" />
            </h2>
            <p className={styles.sectionSubtitle}>
              <FormattedMessage id="aboutSection.description" />
            </p>
          </div>
        </ScrollReveal>

        <div className={styles.capGrid}>
          {capabilities.map((cap, i) => {
            const Icon = cap.icon;
            return (
              <ScrollReveal key={cap.titleId} delay={i * 60}>
                <div className={styles.capCard}>
                  <div className={styles.capIconWrap}>
                    <Icon size={20} aria-hidden="true" />
                  </div>
                  <h3 className={styles.capTitle}>
                    <FormattedMessage id={cap.titleId} defaultMessage={cap.titleDefault} />
                  </h3>
                  <p className={styles.capDesc}>
                    <FormattedMessage id={cap.descId} defaultMessage={cap.descDefault} />
                  </p>
                </div>
              </ScrollReveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default injectIntl(AboutSection);
